module.exports = __webpack_public_path__ + "static/img/two.9c71ac5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/15/two.png
// module id = gWcL
// module chunks = 1